import Swiper, { Navigation } from 'swiper'

const EsgPillars = () => {

  let setingsSwiper = {
    modules: [Navigation],
    slidesPerView: 'auto',
    loop: true,
    slidesOffsetAfter: 50,
    spaceBetween: 0,
    navigation: {
      nextEl: '.esg_pillars .slider-button-next',
      prevEl: '.esg_pillars .slider-button-prev',
    },

    on: {
      slideChange: function () {
        let activeIndex = this.realIndex;
        document.querySelector('.nav-list-esg .active').classList.remove('active')
        let itemNav = document.querySelector('.nav-list-esg [data-item="' + activeIndex + '"]')
        itemNav.classList.add('active')

        let listItens = itemNav.parentNode;
        
        listItens.scrollLeft = itemNav.offsetLeft          
      }
    }
  }
  
  window.addEventListener('load', () => {
    let esgPillarsSlider = new Swiper('.esg-pillars-component', setingsSwiper)

    let navPillars = document.querySelectorAll('.nav-list-esg')

    let component = document.querySelector('.esg-pillars-component')
    let slides = component.querySelectorAll('.swiper-slide')
    let newSlides = Array.from(slides).map(slide => slide.cloneNode(true))
  
    navPillars.forEach(function (nav) {
      let button = nav.querySelectorAll('button')
  
      button.forEach(function (el) {
        el.addEventListener('click', function (event) {
          event.preventDefault()
          const index = parseInt(this.dataset.item)
  
          document
            .querySelector('.nav-list-esg .active')
            .classList.remove('active')
          this.classList.add('active')
  
          esgPillarsSlider.slideTo(index)
        })
      })
    })
  
    function onWindowResize() {
      var swiperWrapper = document.querySelector('.slider-pillars .swiper-wrapper')
      
      setTimeout(() => {
        esgPillarsSlider.destroy();

        let swiperWrapper = document.querySelector('.slider-pillars .swiper-wrapper')
        while (swiperWrapper.firstChild) {
          swiperWrapper.removeChild(swiperWrapper.firstChild);
        }

        newSlides.forEach(slide => {
          swiperWrapper.appendChild(slide);
        });

        esgPillarsSlider = new Swiper('.esg-pillars-component', setingsSwiper)
      }, 1000);
    }
  
    window.addEventListener('resize', onWindowResize);
  }, false);

}

export default EsgPillars